import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Drawer, Popconfirm, Select, Row, Tabs, Tooltip, Switch} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import moment from 'moment'
import _ from 'lodash'
import { Col } from 'antd/es/grid'

const Option = Select.Option

@Form.create()

class AllSyncUsers extends Component {
  state = {
    total: 0,
    assignPhoneRecord: {},
    refreshChild: false,
    tellecallerId: '',
    allUsers: [],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getAllIVRUsers({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSyncUsers = async() => {
    let x = await Request.startSyncUsers();
    if (!x.error) {
      notification.success({
        message: 'Users Sync Successfully'
      })
      if (this.table && this.table.current) {
        this.table.current.reload();
      }
    } else {
      notification.error({
        message: 'Error while syncing',
        description: x.msg
      })
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
    let localUser = JSON.parse(localStorage.getItem("user"));
    
    let { data: allUsers } = await Request.loadDeskUser({
      results: 10000,
      isTelecaller: true,
      active: true,
      userBranch: localUser ? localUser.userBranch : null,
      userId: localUser._id,
    });
    this.setState({ allUsers });
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  changeIVRUserStatus = async ({checked, _id}) => {
    await Request.changeIVRUserStatus({_id, status: checked})
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }
  saveAssignTellecaller = async () => {
    const { assignPhoneRecord, tellecallerId } = this.state
    await Request.saveAssignTellecaller({_id: assignPhoneRecord._id, tellecallerId: tellecallerId})
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }
  
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {id, assignPhoneRecord, drawerVisible} = this.state;
    
    const columns = [
      {
        title: 'Use For Call',
        dataIndex: 'status',
        key: 'status',
        render: (val, record) => {
          return <div>
            <Switch checked={record.status}
              onChange={(checked) => {
                this.changeIVRUserStatus({checked, _id: record._id})
              }}
            />
          </div>
        }
      },
      {
        title: 'TellCaller',
        key: 'tellecallerId',
        render: (val, record) => {
          return <div>{record.tellecallerId?record.tellecallerId.name:''}</div>
        }
      },
      {
        title: 'User ID',
        key: 'user_id',
      },
      {
        title: 'Name',
        key: 'name',
      },
      {
        title: 'Email',
        key: 'email',
      },
      {
        title: 'Contact Number',
        key: 'contact_number',
      },
      {
        title: 'Action',
        key: 'operation',
        dataindex: 'operation',
        width: 130,
        render: (text, record) => (
          <div >
            <Tooltip title="Assign Tellecaller">
              <Button
                size={'small'}
                shape="circle"
                onClick={() => {
                  this.setState({
                    assignPhoneRecord: record,
                    drawerVisible: true
                  })
                }}
                icon="eye"
              />
            </Tooltip>
          </div>
        )
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      }
    ];
    return (
      <PageHeaderWrapper title={` Sync Users `}>
        <Card bordered={true}>
          <Row>
            <Col span={20}>
              <h2>{`Total Users: ${this.state.total}`}</h2>
            </Col>
            <Col span={4}>
              <Button
                style={{
                  marginBottom: 10,
                  marginLeft: '33%',
                  backgroundColor: 'green',
                  color: 'white'
                }}
                loading={this.props.loading}
                onClick={() => {this.handleSyncUsers()}}>Sync</Button>
            </Col>
          </Row>  
          <Drawer
            title="Assign Tellecaller"
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                drawerVisible: false
              })
            }}
            visible={drawerVisible}
            width={400}>
            <div >
              <div style={{textAlign: 'center', padding: 20, fontSize: 12}}>
                <Col span={24}>
                  Assign Tellecaller for
                  {assignPhoneRecord && <b> {assignPhoneRecord.name+'-'+assignPhoneRecord.contact_number}</b>}
                </Col>
                <Col span={24}>
                  <h4>Select Tellecaller User</h4>
                  <Select
                    style={{width: '200px'}}
                    showSearch={true}
                    value={
                      this.state.tellecallerId ? this.state.tellecallerId : []
                    }
                    onChange={item => {
                      this.setState({ tellecallerId: item })
                    }}>
                    {this.state.allUsers.map(item => (
                      <Option key={item._id} value={item._id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{marginBottom: 10, marginLeft: '33%'}}
                    loading={this.props.loading}
                    onClick={this.saveAssignTellecaller}
                    >
                    Save
                  </Button>
                </Col>
              </div>
            </div>
          </Drawer>        
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{scroll: {x: 900}}}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100', '500', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllSyncUsers
